import { apiHelper } from '../utils/newRequestHelpers';

export default {
  getDefaultReplyList() {
    return apiHelper.get('v1/default-replies', {
      params: {
        page: 1,
        pageSize: 10000,
        editable: true
      }
    });
  },
  getDefaultReply(id) {
    return apiHelper({
      url: `v1/default-replies/${id}`,
      method: 'get'
    });
  },
  getDefaultReplyLabelList(params) {
    return apiHelper({
      url: 'v1/default-replies/labels',
      method: 'get',
      params
    });
  },
  createDefaultReply(data) {
    return apiHelper({
      url: 'v1/default-replies',
      method: 'post',
      data
    });
  },
  updateDefaultReply(id, data) {
    return apiHelper({
      url: `v1/default-replies/${id}`,
      method: 'put',
      data
    });
  },
  deleteDefaultReply(id) {
    return apiHelper({
      url: `v1/default-replies/${id}`,
      method: 'delete'
    });
  },
  getAllShopList() {
    return apiHelper.get('v1/shops', {
      params: {
        page: 1,
        pageSize: 10000
      }
    });
  }
};
